export default {
  clientsListMessage: 'files.fileList',
  barcodeModule: 'barcode.name',
  prescriptionModule: 'prescription.name',
  usersModule: 'users.name',
  videoReviewModule: 'videoReview.name',
  testsModule: 'tests.newTestsName',
  immunotherapyModule: 'immunotherapy.name',
  reviewedImmunotherapyModule: 'reviewedImmunotherapy.name',
  reviewedTestsModule: 'tests.reviewedTestsName',
  testAssignmentModule: 'testAssignment.name',
  fertilityCheckModule: 'fertilityCheck.name',
  reviewedFertilityCheckModule: 'reviewedFertilityCheck.name',
  weightLossTreatmentCheckModule: 'weightLossTreatmentCheck.name',
  reviewedWeightLossTreatmentCheckModule: 'reviewedWeightLossTreatmentCheck.name',
  healthCheckBasicModule: 'healthCheckBasic.name',
  reviewedHealthCheckBasicModule: 'reviewedHealthCheckBasic.name',
  cardiovascularAndDiabetesRiskCheckModule: 'cardiovascularAndDiabetesRiskCheck.name',
  reviewedCardiovascularAndDiabetesRiskCheckModule: 'reviewedCardiovascularAndDiabetesRiskCheck.name',
  treatmentsModule: 'treatments.name',
  reviewedTreatmentsModule: 'reviewedTreatments.name',
};
